<template>
	<bsh-modal 
		:titulo="title"
		:name="name">
		<template v-slot:default>
	        <categoria-form
	        	:dados="dados" 
	        	:name="name" 
	        	:errors="errors">
	        </categoria-form>
	    </template>
	    <template v-slot:footer>
        	<button 
				ref="btnRequest"
        		type="button" 
        		class="btn btn-primary" 
        		@click="create">
        		Salvar
        	</button>
        </template>
    </bsh-modal>
</template>

<script>
	import Categoria from "./../../models/Categoria.js";
	export default {
		props: {
	        title: {
	            type: String,
	            default: 'Nova Categoria'
	        },
	        link: {
	            type: String,
	        },
	    },
		data(){
			return {
				dados: new Categoria(),
				name: 'create_categoria',
				errors: []
			}
		}, 
		methods: {
			create(){
				this.$btnFunctions.disableToggle(this.$refs.btnRequest, true)
	            axios.post(this.$url+this.link, (this.dados))
	            .then(response => {
	            	$('#'+this.name).modal('hide')
	            	this.$bshMessage.show(response.data.message, response.data.type)
	              	this.dados = new Categoria()
	              	this.$emit('reload')
					this.$btnFunctions.disableToggle(this.$refs.btnRequest, false)
	            })
	            .catch(error => {
					this.errors = error.response.data.errors
					this.$btnFunctions.disableToggle(this.$refs.btnRequest, false)
				});
        	},
		},
	}
</script>